function LetterHistory(data){
    let letterHistory = data || {};
    this.date = letterHistory.date;
    this.letterProgressStage = letterHistory.letterProgressStage;
    this.details = letterHistory.details;
    this.userId = letterHistory.userId;
}
module.exports = LetterHistory;